import { Fragment, useEffect, useState } from "react";
import DesktopDashboardTemplate from "./DesktopDashboardTemplate";
import MobileDashboardTemplate from "./MobileDashboardTemplate";
import { Event, EventSourcePolyfill } from "event-source-polyfill";
import streamUrl from "../../../config/streamUrl";
import { useDispatch } from "react-redux";
import {
  GetUser,
  GetUserWallet,
} from "../../../store/actions/user/UserActions";
import { setNotificationUnradCount } from "../../../store/actions/notification/NotificationActions";
import { GetPrice } from "../../../store/actions/price/PriceActions";
import { isMobile } from "react-device-detect";

interface Props {
  children?: React.ReactNode;
}

const DashboardTemplate = (props: Props) => {
  const dispatch = useDispatch();

  useEffect(() => {
    try {
      if (localStorage.getItem("isLogin")) {
        dispatch(GetUserWallet());
      }
      return () => {};
    } catch (error) {
      console.log(error);
    }
  }, []);
  useEffect(() => {
    // put in try catch because eventSrc.onmessage and eventSrc.onerror return undefined
    try {
      const token = localStorage.getItem("token");
      const eventSrc = new EventSourcePolyfill(`${streamUrl}changeStatus`, {
        headers: { "Accept-Language": "fa", Authorization: `${token}` },
      });
      eventSrc.onmessage = (result) => {
        switch (result.data) {
          case "PROFILE_CHANGE":
            dispatch(GetUser());
            break;
          case "WALLET_CHANGE":
            dispatch(GetUserWallet());
            break;
          case "NOTIFICATION_CHANGE":
            dispatch(setNotificationUnradCount(0));
            break;
          default:
            break;
        }
      };
      eventSrc.onerror = function (event) {
        console.log(event.type + ": " + event.target);
      };
      return () => {
        eventSrc.close();
      };
    } catch (error) {
      console.log(
        "error in eventSrc onmessage | onerror return undefined",
        error
      );
    }
  }, []);

  useEffect(() => {
    const sse = new EventSource(`${streamUrl}price`);
    function getRealtimeData(data: any) {
      // process the data here,
      // then pass it to state to be rendered
      dispatch(GetPrice(data));
    }
    sse.onmessage = (e) => getRealtimeData(JSON.parse(e.data));
    sse.onerror = (e: any) => {
      // error log here
      // sse.close();
    };
    return () => {
      sse.close();
    };
  }, []);

  return (
    <Fragment>
      {isMobile ? (
        <MobileDashboardTemplate>{props.children}</MobileDashboardTemplate>
      ) : (
        <DesktopDashboardTemplate>{props.children}</DesktopDashboardTemplate>
      )}
    </Fragment>
  );
};

export default DashboardTemplate;
